import Modal from '../Modal';
import { useMemo } from 'react';

export default function Share ({
	setModal,
	// outputHeight,
	outputWidth,
	outputPreset,
	customAspectRatioWidth,
	customAspectRatioHeight
}) {

	const handleClick = async (text) => {
		await navigator.clipboard.writeText(text);
		alert('Text copied!');
	};

	const url = useMemo(function () {
			let params = {
				width: outputWidth,
			};

			if (customAspectRatioWidth > 0 && customAspectRatioHeight > 0) {
				params.custom = encodeURIComponent(`${customAspectRatioWidth}/${customAspectRatioHeight}`);
			} else {
				params.preset = outputPreset;
			}

			let currentUrlParams = new URLSearchParams();

			Object.keys(params).map((key) => {
				currentUrlParams.set(key, params[key]);
				return true;
			});

			return `${window.location.href.split('?')[0]}?${currentUrlParams.toString()}`;
		},
		[
			outputWidth,
			outputPreset,
			customAspectRatioWidth,
			customAspectRatioHeight
		]
	);

	return (
		<Modal setModal={setModal}>

			<h2 className="mb-4">
				Now share your cropper!
			</h2>

			<div className="fs-5  mb-3">
				Do you crop images the same way over and over again?
				Or do you have clients who need to crop images consistently?
			</div>

			<div className="fs-5">
				<label htmlFor="url">Copy this url:</label>
				<div className="input-group">
					<input type="text"
					       readOnly={true}
					       id="url"
					       className="form-control form-control-lg"
					       defaultValue={url}
					/>
					<button
						onClick={() => handleClick(url)}
						className="btn btn-outline-secondary">
						<svg width="1.5em"
						     height="1.5em"
						     viewBox="0 0 256 256"
						     xmlns="http://www.w3.org/2000/svg">
							<path
								d="M216 32H88a8 8 0 0 0-8 8v40H40a8 8 0 0 0-8 8v128a8 8 0 0 0 8 8h128a8 8 0 0 0 8-8v-40h40a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8Zm-56 176H48V96h112Zm48-48h-32V88a8 8 0 0 0-8-8H96V48h112Z"/>
						</svg>
					</button>
				</div>
			</div>
			<div className="fs-5 mb-3">
				And share it!
			</div>
			<div className="fs-5">
				Or click to open it:
			</div>
			<div className="fs-5">
				<a href={url}
				   className="btn btn-primary btn-lg w-100"
				   target="_blank" rel="noreferrer">
					{url}&nbsp;&nbsp;
					<svg width="1.382em" height="1.382em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path fill="none"
						      stroke="currentColor"
						      strokeLinecap="round"
						      strokeLinejoin="round"
						      strokeWidth="2"
						      d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4m-8-2 8-8m0 0v5m0-5h-5"/>
					</svg>
				</a>
			</div>
			<div className="fs-5 mb-3">
				And bookmark it.
			</div>
		</Modal>
	);
}